export default __webpack_public_path__ + "locales/de/EmbeddingPanel.json?hash=840eb827a666a48b48ba4ffd2392fe16";